module.exports = __webpack_public_path__ + "img/rosemount-702-discrete-transmitter-plunger-arrival.b0bd5d1b.png";